// noinspection DuplicatedCode

import React, { useEffect, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { Input, TextArea } from 'components/Forms';
import Dropzone from 'components/Dropzone/Dropzone';

const propTypes = {
  blockId: PropTypes.string,
  title: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  media: PropTypes.object.isRequired,
  // partnerId: PropTypes.string,
};
const defaultProps = {
  blockId: '',
  title: '',
  onCancel: () => null,
  onSubmit: () => null,
  // partnerId: '',
};

export default function BlockParameterEditor(props) {
  const { title, onCancel, onSubmit, media, blockId } = props;
  const [uploadFile, setUploadFile] = useState(null);

  const [previewImageFile, setPreviewImageFile] = useState(null);

  const [noFile, setNoFile] = useState(false);

  const [noPreviewImage, setNoPreviewImage] = useState(false);

  const [notYoutubeUrl, setNotYoutubeUrl] = useState(false);

  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      id: '',
      dataKey: '',
      groupKey: '',
      displayOrder: '',
      title: '',
      description: '',
      mediaType: 'link',
      mediaPath: '',
      mediaPreviewPath: '',
      blockId: '',
    },
  });

  const [selectedType, setSelectedType] = useState('');

  const [disabled, setDisabled] = useState(false);

  const [uid, setUid] = useState(new Date().getTime().toString());

  const onTypeChange = (type) => {
    const radio = document.querySelector(`.media-type-${uid}[value="${type}"]`);
    if (radio) {
      radio.checked = true;
    }
    setSelectedType(type);
    // setValue('mediaPreviewPath', '');
    // setValue('mediaPath', '');
    setValue('mediaType', type);
    // setTimeout(() => , 500);
  };
  const onDropZonePreviewImageUpload = (file) => {
    setPreviewImageFile(file);
    setNoPreviewImage(false);
  };
  const onDropZoneFileUpload = (file) => {
    setUploadFile(file);
    setNoFile(false);
  };

  const onFormSubmit = (formData) => {
    if (!previewImageFile && formData.mediaPreviewPath.length === 0) {
      setNoPreviewImage(true);
      return;
    }

    setNoPreviewImage(false);
    if (formData.mediaType === 'image' || formData.mediaType === 'file') {
      if (!uploadFile && formData.mediaPath.length === 0) {
        setNoFile(true);
        return;
      }
    }
    setNoFile(false);

    if (formData.mediaType === 'youtube') {
      const url = new URL(formData.mediaPath);
      if (
        !url.host.startsWith('www.youtube') &&
        !url.host.startsWith('youtube') &&
        !url.host.startsWith('www.youtu.be') &&
        !url.host.startsWith('youtu.be')
      ) {
        setNotYoutubeUrl(true);
        return;
      }
    }
    const data = {
      dataKey: formData.dataKey,
      groupKey: formData.groupKey,
      value: {
        id: formData.id,
        displayOrder: +formData.displayOrder,
        title: formData.title,
        description: formData.description,
        mediaType: formData.mediaType,
        mediaPath: formData.mediaPath,
        mediaPreviewPath: formData.mediaPreviewPath,
      },
    };
    if (blockId.length === 0) {
      onSubmit({
        type: formData.mediaType,
        data: [data],
        file:
          formData.mediaType === 'image' || formData.mediaType === 'file'
            ? uploadFile
            : null,
        previewImage: previewImageFile,
      });
      setDisabled(true);
      return;
    }
    // process upload if image
    onSubmit({
      data: [data],
    });
    setDisabled(true);
  };
  const acceptedTypes = [
    'image/jpeg',
    'image/gif',
    'image/png',
    'text/plain',
    'application/pdf',
    'application/msword',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ];
  const isItemMedia = () =>
    media?.data && media?.data[0]?.dataKey !== 'item_guid';

  const previewImageSection = () => (
    <div className="d-block mb-3" data-testid="Wrapper-blockParamenterEditor">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="headerPreviewMediaImage" className="me-2">
        <strong>
          {isItemMedia() ? 'Media Preview Image' : 'Item Preview Image'}
        </strong>
      </label>
      {noPreviewImage && (
        <p
          className="alert alert-danger mb-1 p-2 mt-1"
          data-testid="Alert-noFile"
        >
          <FontAwesomeIcon icon={faExclamationCircle} /> Please select a preview
          image file to upload.
        </p>
      )}
      <Dropzone
        accept="image/png,image/gif,image/jpeg,image/jpg"
        disabled={disabled}
        onUpload={onDropZonePreviewImageUpload}
        showAsImage
        value={getValues().mediaPreviewPath}
      />
    </div>
  );

  const onImageType = () => (
    <div className="ease-all d-flex flex-column position-relative">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="mediaPath">
        <strong>Image</strong>
      </label>
      {noFile && (
        <p
          className="alert alert-danger mb-1 p-2 mt-1"
          data-testid="Alert-noFile"
        >
          <FontAwesomeIcon icon={faExclamationCircle} /> Please select an image
          file to upload.
        </p>
      )}
      <Dropzone
        accept="image/png,image/gif,image/jpeg,application/pdf"
        disabled={disabled}
        onUpload={onDropZoneFileUpload}
        showAsImage
        value={getValues().mediaPath}
      />
    </div>
  );

  const onFileType = () => (
    <div className="ease-all d-flex flex-column position-relative">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="mediaPath">
        <strong>Download</strong>
      </label>
      {noFile && (
        <p className="alert alert-danger mb-1 p-2 mt-1">
          <FontAwesomeIcon icon={faExclamationCircle} /> Please select a file to
          upload.
        </p>
      )}
      <Dropzone
        accept={acceptedTypes.join(',')}
        disabled={disabled}
        onUpload={onDropZoneFileUpload}
        value={getValues().mediaPath}
      />
    </div>
  );

  const onLinkType = () => (
    <div className="ease-all">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="mediaPath">
        <strong>Link</strong>
      </label>
      <Input
        disabled={disabled}
        type="url"
        name="mediaPath"
        control={control}
        rules={{ required: true }}
        placeholder="This is the url to link the user to upon clicking the media item"
      />
    </div>
  );

  const onYouTubeType = () => (
    <>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="mediaPath">
        <strong>YouTube Video Url</strong>
      </label>
      <Input
        disabled={disabled}
        type="url"
        name="mediaPath"
        rules={{ required: true }}
        control={control}
        className={notYoutubeUrl ? 'is-invalid' : ''}
        placeholder="This is the YouTube video url"
      />
      {notYoutubeUrl && (
        <p className="alert alert-danger small p-2">
          The specified url is not a YouTube url.
        </p>
      )}
    </>
  );

  useEffect(() => {
    if (media && media.data) {
      const data = media.data[0];
      setValue('dataKey', data.dataKey);
      setValue('value', data.value);
      setValue('groupKey', data.groupKey);
      if (data.value) {
        if (data.value.id) {
          setValue('id', data.value.id);
          setUid(data.value.id);
        }
        if (data.value.displayOrder) {
          setValue('displayOrder', data.value.displayOrder);
        }
        if (data.value.title) {
          setValue('title', data.value.title);
        }
        if (data.value.description) {
          setValue('description', data.value.description);
        }
        if (data.value.mediaType) {
          setValue('mediaType', data.value.mediaType);
        }
        if (data.value.mediaPath) {
          setValue('mediaPath', data.value.mediaPath);
        }
        if (data.value.mediaPreviewPath) {
          setValue('mediaPreviewPath', data.value.mediaPreviewPath);
        }
        if (data.value.blockId) {
          setValue('blockId', data.value.blockId);
        }
      }
      onTypeChange(getValues().mediaType);
    }
  }, [media]);
  useEffect(() => {
    document.getElementById('displayOrder').setAttribute('min', 1);
  }, [getValues().mediaType]);

  return (
    <div
      className={`block-parameter-editor block-parameter-editor-${uid} ease-all`}
    >
      <Form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="mb-3 d-block">
          {title.length > 0 && <h4>{title}</h4>}
          <div className="d-flex space-between">
            <div className="d-block">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="displayOrder">
                <strong>Display Order</strong>
              </label>
              <div className="d-block" style={{ width: '150px' }}>
                <Input
                  disabled={disabled}
                  name="displayOrder"
                  placeholder="Order"
                  control={control}
                  type="number"
                  min="1"
                />
              </div>
            </div>
            <div className="d-block flex-grow-1 ps-2 ps-xl-2 ps-lg-2 ps-m-2 ps-sm-0">
              <label htmlFor="title" className="me-2">
                <strong>{!isItemMedia() ? 'Item Title' : 'Media Title'}</strong>
              </label>
              <Input
                disabled={disabled}
                name="title"
                placeholder="Title"
                control={control}
              />
            </div>
          </div>
          <div className="d-block">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="description">
              <strong>Description</strong>
            </label>
            <TextArea
              disabled={disabled}
              name="description"
              control={control}
            />
          </div>
          {previewImageSection()}
          <div className="d-block">
            <label htmlFor="headerPreviewMediaImage" className="me-2">
              <strong>
                {!isItemMedia() ? 'Item Click Action' : 'Media Click Action'}
              </strong>
            </label>
            <div className="form-check form-check-inline">
              <input
                className={`form-check-input media-type-${uid}`}
                name="media-type"
                type="radio"
                value="link"
                onClick={() => onTypeChange('link')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="form-check-label" htmlFor="mediaTypeLink">
                Link
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                disabled={disabled}
                className={`form-check-input media-type-${uid}`}
                name="media-type"
                type="radio"
                value="youtube"
                onClick={() => onTypeChange('youtube')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="form-check-label" htmlFor="mediaTypeYoutube">
                YouTube
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className={`form-check-input media-type-${uid}`}
                name="media-type"
                type="radio"
                value="file"
                onClick={() => onTypeChange('file')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="form-check-label" htmlFor="mediaTypeFile">
                Download File
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className={`form-check-input media-type-${uid}`}
                name="media-type"
                type="radio"
                value="image"
                onClick={() => onTypeChange('image')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="form-check-label" htmlFor="mediaTypeImage">
                View Image
              </label>
            </div>
          </div>
          <div className="d-block mt-2">
            <hr style={{ opacity: 0.1 }} />
            {selectedType === '' && (
              <div className="ease-all d-flex flex-column position-relative">
                <div className="text-muted text-center">
                  <Spinner size="sm" animation="border" /> Loading...
                </div>
              </div>
            )}
            {selectedType === 'link' && onLinkType()}
            {selectedType === 'youtube' && onYouTubeType()}
            {selectedType === 'image' && onImageType()}
            {selectedType === 'file' && onFileType()}
            <hr style={{ opacity: 0.1 }} />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            className="btn-pmi btn-sm"
            type="submit"
          >
            {disabled ? 'Saving...' : 'Save'}
          </Button>
          <Button
            disabled={disabled}
            variant="link"
            size="sm"
            type="button"
            onClick={onCancel}
            className="ms-3 mt-2 btn-sm"
          >
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}
BlockParameterEditor.propTypes = propTypes;
BlockParameterEditor.defaultProps = defaultProps;
